import React from 'react';

export const Card: React.FC<{
    children: React.ReactNode;
    style?: React.CSSProperties;
}> = ({ children, style }) => {
    return (
        <div
            style={{
                width: '95%',
                position: 'relative',
                borderRadius: 15,
                overflow: 'hidden',
                margin: 'auto',
                boxShadow:
                    'rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px',
                ...(style || {}),
            }}
        >
            {children}
        </div>
    );
};
